import { createElement as h } from "react"

import { pipe } from "fp-ts/es6/function"
import { assoc, find, identity, prop, propEq, T } from "ramda"
import { isNilOrEmpty } from "ramda-extension"

import { Logic } from "@cirrus/fe-lib"

export const withHeight = (typography) => (props) =>
  pipe(
    props,

    Logic.condition(
      [propEq("size", "medium"), assoc("height", typography.pxToRem(44))],
      [propEq("size", "small"), assoc("height", typography.pxToRem(38))],
      [T, identity],
    ),
  )

export const valueRenderFor = (options, renderPlaceholder) => (value) =>
  renderPlaceholder && isNilOrEmpty(value)
    ? h("span", { className: "selector-label" }, renderPlaceholder(options))
    : h(
        "span",
        { className: "selector-label" },
        pipe(options, find(propEq("value", value)), prop("title")),
      )
